<template>
  <div :id="genericPopupId" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header generic-header">
          <template v-if="genericBody !== 'Renew Certificate' && genericBody !== 'Revision'">
            <span class="col-md-12 pt-10">{{genericHeaderLocal}}</span>
          </template>
        </div>
        <div class="modal-body generic-body">
          <div class="col-md-12 p-10" v-if="genericBody">
            <div class="modal-body-text">
              <p v-if="genericBody !== 'Renew Certificate' && genericBody !== 'Revision'">
                {{$t('genericPopupDesc1')}} {{isREP ? this.max_number -1 : this.max_number}}
                <template
                  v-if="genericBody==='upgradeTeams'"
                >{{$t('membersWithSmallM')}}.</template>
                <template v-if="genericBody==='upgradeRecords'">records.</template>
              </p>
              <p v-if="genericBody !== 'Renew Certificate' && genericBody !== 'Revision'">{{$t('genericPopupDesc2')}}</p>
              <p v-if="genericBody === 'Renew Certificate'" class="renew-certificate">{{$t('renewalMessage')}}</p>
              <p v-if="genericBody === 'Revision'" class="renew-certificate">{{$t('revisionMessage')}}</p>
              <!-- <p class="inlineStyle">
                Please
                <span class="rams_url" @click="upgrade">Click here</span> if you would like to upgrade your account.
              </p> -->
            </div>
          </div>
        </div>
        <div class="modal-footer" style="clear: both;">
          <button type="button" class="btn team-limit-footer min-width-90" @click="closePopupOnOk">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  props: {
    genericPopupId: String,
    genericHeader: String,
    genericBody: String,
    emitUpgradeRecords: Function,
    emitUpgradeTeams: Function,
    max_number: Number,
    isREP: Boolean,
  },
  data() {
    return {
      genericHeaderLocal: this.genericHeader,
    };
  },
  methods: {
    closePopupOnOk() {
      if (this.genericPopupId === 'genericPopupRenewCertificate') {
        $('#basePopup').modal('hide');
        this.$router.go();
      }
      $(`#${this.genericPopupId}`).modal('hide');
    },
    async upgrade() {
      if (this.genericBody === 'upgradeRecords') {
        setTimeout(() => {
          $(`#${this.genericPopupId}`).modal('hide');
        }, 200);
        this.$emit('emitUpgradeRecords');
      } else if (this.genericBody === 'upgradeTeams') {
        setTimeout(() => {
          $(`#${this.genericPopupId}`).modal('hide');
        }, 200);
        this.$emit('emitUpgradeTeams');
      }
    },
  },
  watch: {},
  created() {
    if (this.$i18n.locale === 'Portuguese') {
      this.genericHeaderLocal = 'Limite de equipe';
    }
  },
  mounted() {},
};
</script>
<style scoped>
.renew-certificate{
  line-height: 30px;
  color: #333333;
  padding: 0px 50px 0px 50px;
}
.modal-header {
  border-bottom: none !important;
  background: #ffffff;
  border-radius: 3px;
}
.modal-footer {
  border-top: none !important;
  background: #ffffff;
  border-radius: 3px;
}
.team-limit-footer, .team-limit-footer:hover {
  background:  #01518A;
  border-radius: 5px;
  color: #ffffff;
  font-size: 18px;
}
.modal-body-text {
  font-size: 18px;
  color: #333333;
}
.p-10 {
  padding: 10px;
}
.pt-10 {
  padding-top: 10px;
}
.modal-lg {
  width: 500px;
}
.generic-header {
  font-weight: 600;
  text-align: center;
  font-size: 22px;
  color: #333333;
}
.generic-body {
  padding: 20px 0px 10px;
  text-align: center;
  font-family: 'Open Sans';
  color: rgba(0, 0, 0, 0.87);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
}
.rams_url {
  color: #337ab7;
}
.inlineStyle {
  display: inline;
}
.a-link {
  font-size: 20px;
  color: #0b3c61;
}
</style>
